import $ from '@vaersaagod/tools/Dom';

export default el => {
    const scroller = $(el);

    const init = () => {
        scroller.on('click', e => {
            e.preventDefault();
            const offset = $(e.triggerTarget.getAttribute('href')).position().top;
            TweenLite.to(window, 1.5, { scrollTo: { y: offset, autoKill: false }, ease: Cubic.easeInOut });
        });
    };

    const destroy = () => {
        scroller.off('click');
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/ScrollToTarget.js